<template>
	<template v-if="type === 'defined'">
		<div class="d-flex" style="flex-direction: column; row-gap: 1rem">
			<template
				v-for="(choice, index) in userDefined(question)"
				:key="index"
			>
				<div
					class="col p-0 d-flex align-items-center justify-content-end"
					style="min-height: fit-content"
				>
					<label class="text-nowrap black"> {{ choice }} </label>
					<label
						class="customcheck ml-1"
						:style="
							isView
								? {
										'pointer-events': 'none',
									}
								: ''
						"
					>
						<input
							:disabled="isView"
							@input="handleRadioChange(index)"
							:checked="
								selectedIndex === index || answer === choice
							"
							:id="
								'choice_' +
								props.question.templates_id +
								'_' +
								index
							"
							:name="String(props.question.templates_id)"
							:value="choice"
							type="radio"
						/>
						<div
							:style="
								isView
									? {
											'background-color':
												'white!important',
										}
									: ''
							"
							class="checkmark"
						/>
					</label>
				</div>
			</template>
		</div>
	</template>
	<template v-else-if="type === 'yesno'">
		<div class="d-flex" style="column-gap: 1rem">
			<div
				class="col p-0 d-flex align-items-center justify-content-end"
				style="min-height: fit-content"
			>
				<label class="text-nowrap black"> Ja </label>

				<label
					class="customcheck ml-1"
					:style="
						isView
							? {
									'pointer-events': 'none',
								}
							: ''
					"
				>
					<input
						:disabled="isView"
						@input="(e) => $emit('update:answer', e.target.value)"
						:model-value="answer"
						:checked="answer === 'yes'"
						:id="props.question.templates_id"
						:name="String(props.question.templates_id)"
						value="yes"
						:type="isView ? 'checkbox' : 'radio'"
					/>
					<div
						:style="
							isView
								? {
										'background-color': 'white!important',
									}
								: ''
						"
						class="checkmark"
					/>
				</label>
			</div>
			<div
				class="col p-0 d-flex align-items-center justify-content-end"
				style="min-height: fit-content"
			>
				<label class="text-nowrap black"> Nej </label>

				<label
					class="customcheck ml-1"
					:style="
						isView
							? {
									'pointer-events': 'none',
								}
							: ''
					"
				>
					<input
						:disabled="isView"
						@input="(e) => $emit('update:answer', e.target.value)"
						:model-value="answer"
						:checked="answer === 'no'"
						:id="props.question.templates_id"
						:name="String(props.question.templates_id)"
						value="no"
						:type="isView ? 'checkbox' : 'radio'"
					/>
					<div
						:style="
							isView
								? {
										'background-color': 'white!important',
									}
								: ''
						"
						class="checkmark"
					/>
				</label>
			</div>
		</div>
	</template>
	<template v-else-if="type === 'text'">
		<base-textarea-group
			ref="textAreaRefs"
			:is-view="isView"
			:style="
				isView
					? { backgroundColor: '#ECEFF1' }
					: { backgroundColor: 'white', minHeight: '18.7rem' }
			"
			@input="(e) => (textAnswer = e.target.value)"
			:model-value="answer"
			:id="props.question.templates_id"
			:name="String(props.question.templates_id)"
			:col-input="12"
			:placeholder="question.helptext"
		>
		</base-textarea-group>
	</template>
	<template v-else-if="type === 'numerical'">
		<div
			class="d-flex"
			style="gap: 1rem; flex-wrap: wrap; justify-content: flex-end"
		>
			<div
				v-for="(choice, index) in numericalChoices"
				:key="index"
				class="d-flex"
				style="
					height: fit-content;
					width: 4rem;
					justify-content: flex-end;
				"
			>
				<label class="text-nowrap black align-center">{{
					index + 1
				}}</label>
				<label
					class="customcheck ml-1"
					:style="
						isView
							? {
									'pointer-events': 'none',
								}
							: ''
					"
				>
					<input
						:disabled="isView"
						@input="(e) => $emit('update:answer', e.target.value)"
						:model-value="answer"
						:checked="answer == choice.i + 1"
						:id="props.question.templates_id"
						:name="String(props.question.templates_id)"
						:type="isView ? 'checkbox' : 'radio'"
						:value="choice.i + 1"
					/>
					<div
						class="checkmark"
						:style="{
							'box-shadow': choice.marker
								? '0px 0px 4px 2px green'
								: '',
							'background-color': isView ? 'white!important' : '',
						}"
					></div>
				</label>
			</div>
		</div>
	</template>
	<template v-else-if="type === 'date'">
		<div>
			<date-picker
				:is-view="isView"
				@change="dateAnswerChanged"
				:model-value="answer"
				no-date
				:id="props.question.templates_id"
				:name="String(props.question.templates_id)"
				:disabled="isView"
			/>
		</div>
	</template>
	<template v-else-if="type === 'file'">
		<div>
			<label
				>Vælg flere filer ved at holde knapperne ”Shift” eller ”Ctrl”
				nede og markér herefter de ønskede filer</label
			>
			<input
				:disabled="isView"
				:style="
					isView
						? {
								'background-color': 'white',
							}
						: ''
				"
				:model-value="answer"
				:id="props.question.templates_id"
				:name="String(props.question.templates_id)"
				type="file"
				multiple
			/>
		</div>
	</template>
</template>

<script setup>
import DatePicker from "@elements/datePicker/DatePicker.vue";
import BaseTextareaGroup from "@elements/form/BaseTextareaGroup.vue";
import { computed, onMounted, ref, watch } from "vue";

const props = defineProps(["question", "answer", "isView"]);
const answer = ref(props.answer);

watch(
	answer,
	(newAnswer, oldAnswer) => {
		emit("update:answer", newAnswer);
	},
	{ deep: true },
);

watch(
	() => props.answer,
	(newAnswer) => {
		answer.value = newAnswer;
	},
	{ deep: true, immediate: true },
);

const type = computed(() => {
	const cleanType = props.question.question_type.trim();
	return types[cleanType];
});

const types = {
	"Brugerdefineret skala": "defined",
	Dato: "date",
	"Ja eller nej": "yesno",
	"Numerisk skala": "numerical",
	Tekstfelt: "text",
	"Vedhæft fil": "file",
};

const textAnswer = ref("");
watch(textAnswer, () => {
	emit("update:answer", textAnswer.value);
});
const emit = defineEmits(["update:answer"]);

const userDefined = (question) => {
	return question.helptext.split(",");
};
const selectedIndex = ref(null);
const selectedValue = ref(null);
const handleRadioChange = (index) => {
	const choices = userDefined(props.question);
	const selectedVal = choices[index];
	selectedValue.value = selectedVal;
	selectedIndex.value = index;
	emit("update:answer", selectedVal);
};

const numericalChoices = computed(() => {
	return generateNumericalChoices();
});

const scaleArray = computed(() => {
	return props.question.helptext.split(",");
});

const generateNumericalChoices = () => {
	const amount = parseInt(scaleArray.value[0], 10);
	const index = parseInt(scaleArray.value[2], 10);

	const numericalChoices = [];
	for (let i = 0; i < amount; i++) {
		const choice = { i };
		if (i + 1 === index) {
			choice.marker = true;
		}
		numericalChoices.push(choice);
	}
	return numericalChoices;
};
const dateAnswerChanged = (e) => {
	answer.value = e.value;
	emit("update:answer", e.value);
};
const textAreaRefs = ref([]);
const observeNoteClamp = () => {
	const textAreas = textAreaRefs?.value;
	if (!textAreas || !props.isView) return;

	const noteBodyArray = Array.isArray(textAreas) ? textAreas : [textAreas];
	noteBodyArray.forEach((component) => {
		const textarea = component?.textAreaRef;
		if (textarea) {
			autoResizeTextarea(textarea);
		}
	});
};
const autoResizeTextarea = (textarea) => {
	const contentHeight = Math.min(textarea.scrollHeight + 2, 299.2);

	const computedStyle = window.getComputedStyle(textarea);
	const paddingTop = parseFloat(computedStyle.paddingTop);
	const paddingBottom = parseFloat(computedStyle.paddingBottom);

	textarea.style.height = `${contentHeight + paddingTop + paddingBottom}px`;
	if (textarea.scrollHeight > 299.2) {
		textarea.style.overflowY = "auto";
	} else {
		textarea.style.overflowY = "hidden";
	}
};
onMounted(() => {
	observeNoteClamp();
});
</script>
